// Configuration centralisée de la visibilité des modules
export const MODULE_CONFIG = {
  'part-1': {
    id: 'part-1',
    title: 'Présentation du module',
    subtitle: 'Prise en main de MI-LXC',
    icon: '🚀',
    color: '#4ecdc4',
    description:
      'Introduction aux enjeux cybersécurité et découverte de MI-LXC',
    visible: true
  },
  'part-2': {
    id: 'part-2',
    title: 'ARP Spoofing',
    subtitle: 'Attaques réseau',
    icon: '🎯',
    color: '#ff6b6b',
    description: 'Comprendre et pratiquer les attaques ARP',
    visible: true
  },
  'part-3': {
    id: 'part-3',
    title: 'HTTPS & Reverse Proxy',
    subtitle: 'Sécurisation web',
    icon: '🔒',
    color: '#45b7d1',
    description: 'Chiffrement et protection des communications web',
    visible: true
  },
  'part-4': {
    id: 'part-4',
    title: 'Firewall Linux',
    subtitle: 'iptables',
    icon: '🔥',
    color: '#f9ca24',
    description: 'Configuration et gestion des pare-feu Linux',
    visible: true
  },
  'part-5': {
    id: 'part-5',
    title: 'pfSense Firewall',
    subtitle: 'Solution professionnelle',
    icon: '🛡️',
    color: '#6c5ce7',
    description: 'Découverte de pfSense et de ses fonctionnalités avancées',
    visible: true
  }
  // tps: {
  //   id: 'tps',
  //   title: 'Travaux Pratiques',
  //   subtitle: 'Exercices pratiques',
  //   icon: '📚',
  //   color: '#27ae60',
  //   description: 'Accédez aux exercices et travaux pratiques du module',
  //   visible: true
  // }
};

// Export des modules pour la page d'accueil
export const MODULES = Object.values(MODULE_CONFIG);

// Export de la visibilité pour App.jsx
export const MODULE_VISIBILITY = Object.keys(MODULE_CONFIG).reduce(
  (acc, key) => {
    acc[key] = MODULE_CONFIG[key].visible;
    return acc;
  },
  {}
);
